import { useMemo } from 'react'
import { useDrawer } from '@core/context/DrawerContext'
import { useAllIssues } from '@/ui/routes/issues/hooks/useAllIssues'

export const useTechnologyDetails = () => {
    const { drawerState } = useDrawer()
    const { currentIndex, technologies } = drawerState?.contentProps || {}
    const filteredTechnologies: TTechnology[] = technologies ?? []
    const currentTechnology: TTechnology | undefined =
        filteredTechnologies[currentIndex]
    const { data: allIssues } = useAllIssues()

    const drawerIssues = currentTechnology?.issues as TIssue[] | undefined

    const enrichedTechnologyIssues: TIssue[] = useMemo(() => {
        if (!drawerIssues) return []

        const openTechnologyIssues = drawerIssues.filter(
            (technologyIssue: TIssue) => technologyIssue.status === 'open'
        )

        const enrichedIssues = openTechnologyIssues.flatMap(
            (technologyIssue: TIssue) =>
                allIssues.filter(
                    (issue: TIssue) => issue.name === technologyIssue.name
                )
        )

        return enrichedIssues.sort(
            (a: TIssue, b: TIssue) =>
                (b?.severity_score || 0) - (a?.severity_score || 0)
        )
    }, [allIssues, drawerIssues])

    return {
        currentTechnology,
        enrichedTechnologyIssues,
    }
}
